import ListProcesses from "@/views/organization/production/productivity_by_producer_exp/ListProcesses.vue";
import ShowProcess from "@/views/organization/production/productivity_by_producer_exp/ShowProcess.vue";
import ShowProducer from "@/views/organization/production/productivity_by_producer_exp/ShowProducer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "production",
  permission: "productivity_by_producer_exp"
});

export default [
  {
    path: "/org/:organization_id/production/productivity_by_producer_exp/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/org/:organization_id/production/productivity_by_producer_exp/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/production/productivity_by_producer_exp/show_process/:harvest_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/production/productivity_by_producer_exp/show_producer/:harvest_process_id/:producer_id",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  }
]
